import { Injectable, inject } from "@angular/core";
import { catchError, map, switchMap, withLatestFrom } from "rxjs";

import { Actions, createEffect, ofType } from "@ngrx/effects";

// Store
import { Store } from "@ngrx/store";
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";
import { SportsbookFacade } from "../../../stores/sportsbook/sportsbook.facade";
import { SportsbookState } from "../../../stores/sportsbook/sportsbook.reducers";

// Services
import { SportTrackPollingService } from "@sports-services/index";
import { SPORTS_NAVIGATION_SERVICE_ERROR_CODES } from "@sports-services/sports.navigation.service";
import { SportService } from "@sports-services/sports.service";

// Models
import * as models from "@sports-models/index";

import { SPORTS_NAVIGATION_SERVICE_ERROR_LOCATION } from "@sports-services/sports.navigation.service/sports.navigations.constants";
// Utils
import { RacePageUtils } from "../../../utils/racePageUtils.utils";

@Injectable({ providedIn: "root" })
export class SportsbookRaceEffects {
  // Services
  actions$ = inject(Actions);
  sportService = inject(SportService);

  // Utils
  racePageUtils = inject(RacePageUtils);
  store = inject(Store<SportsbookState>);
  sportsbookFacade = inject(SportsbookFacade);
  sportTrackPollingService = inject(SportTrackPollingService);

  // RACE
  fetchRace$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SportsbookActions.fetchRace),
      withLatestFrom(this.store.select("sportsbook")),
      switchMap(([raceData, sportsbook]) => {
        const racePageData = sportsbook["raceData"];
        const endOfToday = raceData.endOfToday;
        this.sportTrackPollingService.stopAllPollings();
        return this.sportService.getRacesInfo(raceData.raceType).pipe(
          map((data) => {
            const nextRaces = data.nextRaces.map(
              (race: models.C_Horses) =>
                (race = new models.C_Horses(
                  race.Name,
                  race.NodeId,
                  race.ParentNodeId,
                  race.EventNodeTypeId,
                  race.Priority,
                  race.SportHandle,
                  race.ChildrenCount,
                  race.CountryCode,
                  race.IsActive,
                  race.OddsAvailability,
                  race.PaddockId,
                  race.StartDate,
                  race.GameTypeId,
                  race.Races,
                  race.Locked,
                  race.StreamingEnabled,
                )),
            );
            const { today, tomorrow } = this.racePageUtils.setPaddocksByDate(data.racesbyPaddock, endOfToday);
            return SportsbookActions.setRace({
              filters: racePageData.filters,
              selectedFilter: racePageData.selectedFilter ? racePageData.selectedFilter : racePageData.filters[0],
              next: nextRaces,
              today,
              tomorrow,
            });
          }),
          catchError((e) => {
            this.sportsbookFacade.setSportsError({
              errorCode: SPORTS_NAVIGATION_SERVICE_ERROR_CODES.GENERIC_ERROR,
              errorDescription: SPORTS_NAVIGATION_SERVICE_ERROR_LOCATION.LOCATION_18,
            });
            return [];
          }),
        );
      }),
    ),
  );
}
